// @format

/*
 * NodeJS app-config loader -- but in the browser
 *
 * The expectation is that runtime libraries (nw-app-module) will
 * inject the below global into the environment with the appropriate
 * browser settings.
 *
 */
import key from '../browser-key';

if (process.env.NODE_ENV !== 'production' && !window[key]) {
  // eslint-disable-next-line
  console.error("Unable to load browser app-config in window[".concat(key, "]. See https://github.com/NerdWallet/app-configs"));
}

export default window[key];